import { StrictRouteConfig } from "@/router/router";

export const userRoutes: StrictRouteConfig[] = [
    // {
    //     path: "/customers/:customerId/users",
    //     name: "users-tabs",
    //     component: () => import(/* webpackChunkName: "user" */ "@/views/users-tabs.vue"),
    //
    //     children: [
    //         {
    //             path: "browse",
    //             name: "users",
    //             component: () => import(/* webpackChunkName: "user" */ "@/views/users.vue"),
    //
    //             meta: {
    //                 requiresAuth: true,
    //                 label: "Users",
    //                 title: "Manage users",
    //                 includeInNavigation: true,
    //                 icon: "card-account-details-outline",
    //                 matchExact: true,
    //                 path: ["dashboard", "users"],
    //                 order: 40,
    //             },
    //         },
    //         {
    //             path: "teams",
    //             name: "teams",
    //             component: () => import(/* webpackChunkName: "team" */ "@/views/teams.vue"),
    //             meta: {
    //                 requiresAuth: true,
    //                 label: "Teams",
    //                 title: "Manage teams",
    //                 includeInNavigation: true,
    //                 icon: "account-group-outline",
    //                 matchExact: true,
    //                 path: ["dashboard", "teams"],
    //                 order: 50,
    //             },
    //         },
    //     ],
    //
    //     meta: {
    //         requiresAuth: true,
    //         label: "Users",
    //         title: "Users tab",
    //         includeInNavigation: true,
    //         icon: "card-account-details-outline",
    //         matchExact: true,
    //         path: ["dashboard", "users"],
    //         order: 40,
    //     },
    // },
    {
        path: "/customers/:customerId/users",
        name: "users",
        component: () => import(/* webpackChunkName: "user" */ "@/views/users/users.vue"),

        meta: {
            requiresAuth: true,
            label: "Users",
            title: "Manage users",
            includeInNavigation: true,
            icon: "card-account-details-outline",
            matchExact: true,
            path: ["dashboard", "users"],
            order: 40,
        },
    },
    {
        path: "/customers/:customerId/users/import",
        name: "user-import",
        component: () => import(/* webpackChunkName: "user" */ "@/views/users/user-import.vue"),
        meta: {
            requiresAuth: true,
            label: "Import users",
            title: "Import users",
            includeInNavigation: false,
            icon: "file-upload-outline",
            matchExact: true,
            path: ["dashboard", "users", "user-import"],
        },
    },
    {
        path: "/customers/:customerId/users/:userId",
        name: "user",
        component: () => import(/* webpackChunkName: "user" */ "@/views/users/user.vue"),
        meta: {
            requiresAuth: true,
            label: "User",
            title: "Manage user",
            icon: "card-account-details-outline",
            matchExact: true,
            path: ["dashboard", "users", "user"],
        },
    },
    {
        path: "/customers/:customerId/users/:userId/teams",
        name: "user-teams",
        component: () => import(/* webpackChunkName: "user" */ "@/views/users/user-teams.vue"),
        meta: {
            requiresAuth: true,
            label: "User",
            title: "User teams",
            icon: "card-account-details-outline",
            matchExact: true,
            path: ["dashboard", "users", "user"],
        },
    },
    {
        path: "/customers/:customerId/users/:userId/reservations",
        name: "user-reservations",
        component: () => import(/* webpackChunkName: "user" */ "@/views/users/user-reservations.vue"),
        meta: {
            requiresAuth: true,
            label: "User",
            title: "User reservations",
            icon: "card-account-details-outline",
            matchExact: true,
            path: ["dashboard", "users", "user"],
        },
    },
];
